import { PivotControls } from '@react-three/drei';
import { useRef, useState } from 'react';
import { Euler, Quaternion, Vector3 } from 'three';
import { DEG2RAD, RAD2DEG } from 'three/src/math/MathUtils';
import { CurvedText } from './CurvedText';


export const TextNode = ({name, position, rotation, scale, text, showGizmo, color, bendFactor, textHeight}) => {
    const refText = useRef(null);
	const [curText, setText] = useState("");

    const logTextTr = () => {
        if (!refText.current) { return; }
        const v3 = new Vector3();
        refText.current.getWorldPosition(v3);
        const sPost = `position: [${ v3.toArray().map(x => x.toFixed(3))}],`;
        const quat = new Quaternion();
        refText.current.getWorldQuaternion(quat);
        const euler = new Euler();
        euler.setFromQuaternion(quat);
        v3.setFromEuler(euler);
        const sRot = `rotation: [${ v3.toArray().map(x => (x*RAD2DEG).toFixed(1))}],`;
        console.log(sPost + "\n" + sRot);
        refText.current.getWorldScale(v3);
        console.log("text world scale: " + v3.toArray());
    }

    const userData = {
        setText,
    };

    const InnerText = () => (
        <group 
            ref={refText}
            position={position}
            rotation={(rotation || [0,0,0]).map(x => x * DEG2RAD)}
            scale={scale}
        >
            <CurvedText
                name= {name || "text_node"}
                text={curText || text || ""}
                bendFactor={bendFactor}
                color={color}
                textHeight={textHeight}
                userData={userData}
            />
        </group>
    )

    return (
        showGizmo ?
        <PivotControls onDragEnd={logTextTr} extra>
            {InnerText()}
        </PivotControls> :
        InnerText()
    )
}
